import { useCallback, useEffect, useState } from 'react';
import client from '../../../shared/api/client';
import { toastError } from '../../../shared/toastHelper';

export function useUserManualSections(enabled) {
  const [sections, setSections] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!enabled || sections) return undefined;
    let ignore = false;
    setLoading(true);
    setError(false);
    client.get('/user_manual.json')
      .then((response) => {
        if (!ignore) setSections(response.data.sections);
      })
      .catch(() => {
        if (ignore) return;
        setError(true);
        toastError("Couldn't load the Help Center. Try again.");
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [enabled, sections, attempt]);

  const reload = useCallback(() => setAttempt((count) => count + 1), []);

  return { sections, loading, error, reload };
}
